"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonSession = void 0;
var session_abstract_1 = require("./session-abstract");
var common_network_1 = __importDefault(require("../network/common-network"));
var common_impl_1 = __importDefault(require("../atomic-request/request-encrypt-v5/common-impl"));
var helper_1 = require("../../core/helper");
var helper_factory_1 = __importDefault(require("../helper/helper-factory"));
var CommonSession = /** @class */ (function (_super) {
    __extends(CommonSession, _super);
    function CommonSession() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // chatSession: any;
        // 服务端建议 app_symbol 相同时共用同一个sessionId
        _this.sessions = new Map();
        return _this;
    }
    // 创建会话
    CommonSession.prototype.createSession = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var _a, _b, headers, params, appSymbol, session, result, error_1;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _a = data || {}, _b = _a.headers, headers = _b === void 0 ? {} : _b, params = _a.params;
                                    appSymbol = params === null || params === void 0 ? void 0 : params.basic_info.app_symbol;
                                    session = this.getSessionItem(appSymbol);
                                    if (session) {
                                        resolve(session);
                                        return [2 /*return*/];
                                    }
                                    _c.label = 1;
                                case 1:
                                    _c.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, common_network_1.default.request({
                                            url: '/ai_entry/v3/sessions/create',
                                            method: 'POST',
                                            headers: headers,
                                            data: params
                                        })];
                                case 2:
                                    result = _c.sent();
                                    if (result.code === 0) {
                                        this.sessions.set(appSymbol, result.data);
                                        resolve(result.data);
                                        return [2 /*return*/];
                                    }
                                    reject(result);
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _c.sent();
                                    reject(error_1);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    CommonSession.prototype.getChatSessionId = function () {
        return { result: { chat_sess_id: '' } };
    };
    CommonSession.prototype.closeSession = function () { };
    CommonSession.prototype.refreshSession = function () { };
    CommonSession.prototype.getSessionItem = function (appSymbol) {
        var _a;
        if (this.sessions.has(appSymbol)) {
            var session = this.sessions.get(appSymbol);
            var isValid = false;
            var expireTime = ((_a = session === null || session === void 0 ? void 0 : session.sess_info) === null || _a === void 0 ? void 0 : _a.expire_at) || (session === null || session === void 0 ? void 0 : session.expire_at) || 0;
            if (expireTime > Date.now()) {
                isValid = true;
            }
            if (isValid) {
                return session;
            }
        }
        return null;
    };
    CommonSession.prototype.createSessionV5 = function (data) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var appSymbol, useCache, session, path, result, error_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        appSymbol = (_a = data['params']) === null || _a === void 0 ? void 0 : _a.scene.symbol;
                        useCache = (_b = data['useCache']) !== null && _b !== void 0 ? _b : true;
                        session = this.getSessionItem(appSymbol);
                        if (useCache && session) {
                            return [2 /*return*/, session];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        path = '/office/v5/ai/sessions/create';
                        return [4 /*yield*/, this.sessionRequestV5(data, path)];
                    case 2:
                        result = _c.sent();
                        console.log('ai sdk common createSessionV5: ', result);
                        if (result.code === 0) {
                            this.sessions.set(appSymbol, result.data);
                        }
                        return [2 /*return*/, result];
                    case 3:
                        error_2 = _c.sent();
                        console.log('ai sdk common session createSessionV5 error: ', error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CommonSession.prototype.getCacheSymbol = function (sessionId) {
        var symbol = '';
        this.sessions.forEach(function (item, key) {
            var id = item.chat_sess_id || item.session_id;
            if (id === sessionId) {
                symbol = key;
            }
        });
        return symbol;
    };
    CommonSession.prototype.closeSessionV5 = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var params, _a, headers, sessionId, cacheSymbol, appSymbol, session, path, result, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        params = data.params, _a = data.headers, headers = _a === void 0 ? {} : _a;
                        sessionId = params.session_id;
                        cacheSymbol = params.symbol;
                        if (sessionId) {
                            cacheSymbol = this.getCacheSymbol(sessionId);
                        }
                        if (!sessionId) {
                            appSymbol = params.symbol;
                            if (!appSymbol) {
                                throw Error('closeSessionV5: session_id or symbol is required');
                            }
                            session = this.getSessionItem(appSymbol);
                            sessionId = (session === null || session === void 0 ? void 0 : session.chat_sess_id) || (session === null || session === void 0 ? void 0 : session.session_id);
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        path = "/office/v5/ai/sessions/".concat(sessionId, "/close");
                        return [4 /*yield*/, this.sessionRequestV5({
                                headers: headers,
                                params: {
                                    session_id: sessionId
                                }
                            }, path)
                            // 删除缓存
                        ];
                    case 2:
                        result = _b.sent();
                        // 删除缓存
                        cacheSymbol && this.sessions.delete(cacheSymbol);
                        return [2 /*return*/, result];
                    case 3:
                        error_3 = _b.sent();
                        console.log('ai sdk common session closeSessionV5 error: ', error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CommonSession.prototype.getSessionListV5 = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var path, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        path = '/office/v5/ai/sessions/list';
                        return [4 /*yield*/, this.sessionRequestV5(data, path)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_4 = _a.sent();
                        console.log('ai sdk common session getSessionListV5 error: ', error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CommonSession.prototype.getMessageListV5 = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var path, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        path = '/office/v5/ai/sessions/history/list';
                        return [4 /*yield*/, this.sessionRequestV5(data, path)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_5 = _a.sent();
                        console.log('ai sdk common session getMessageListV5 error: ', error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CommonSession.prototype.setFeedbackV5 = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, headers, params, session_id, history_id, reset, path, error_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = data.headers, headers = _a === void 0 ? {} : _a, params = data.params;
                        session_id = params.session_id, history_id = params.history_id, reset = __rest(params, ["session_id", "history_id"]);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        path = "/office/v5/ai/sessions/".concat(session_id, "/history/").concat(history_id, "/feedback");
                        return [4 /*yield*/, this.sessionRequestV5({ headers: headers, params: reset }, path)];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3:
                        error_6 = _b.sent();
                        console.log('ai sdk common session setFeedbackV5 error: ', error_6);
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CommonSession.prototype.applyMessageV5 = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var params, session_id, reset, path, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        params = data.params;
                        session_id = params.session_id, reset = __rest(params, ["session_id"]);
                        path = "/office/v5/ai/sessions/".concat(params.session_id, "/history/apply");
                        return [4 /*yield*/, this.sessionRequestV5(__assign(__assign({}, data), { params: reset }), path)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_7 = _a.sent();
                        console.log('ai sdk common session applyMessageV5 error: ', error_7);
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CommonSession.prototype.sessionRequestV5 = function (data, path) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, headers, baseUrl, timeout, params, headersV5, mergedHeaders, result, error_8;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = data || {}, _b = _a.headers, headers = _b === void 0 ? {} : _b, baseUrl = _a.baseUrl, timeout = _a.timeout, params = _a.params;
                        if (!path.startsWith('http') && !baseUrl) {
                            baseUrl = (0, helper_1.getBaseUrlV5)();
                        }
                        headersV5 = helper_factory_1.default.getAiServerHeadersV5();
                        mergedHeaders = helper_factory_1.default.getObjKeysMerged(headersV5, headers);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, common_impl_1.default.request({
                                url: "".concat(baseUrl || '').concat(path),
                                method: 'POST',
                                timeout: timeout || 20000,
                                headers: __assign(__assign({}, mergedHeaders), { 'Content-Type': 'application/json' }),
                                data: params
                            })];
                    case 2:
                        result = _c.sent();
                        console.log('ai sdk common session sessionRequestV5: ', result);
                        return [2 /*return*/, result];
                    case 3:
                        error_8 = _c.sent();
                        console.log('ai sdk common session sessionRequestV5 error: ', error_8);
                        throw error_8;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return CommonSession;
}(session_abstract_1.SessionAbstract));
exports.CommonSession = CommonSession;
exports.default = new CommonSession();
